/** 系统管理路由 */
// import Layout from '@/views/layout/AdminLayout';
// const layout = function(meta = {}, path = '/manage', requiresAuth = true) {
//   return {
//     path: path,
//     // component: Layout,
//     meta: {
//       requiresAuth: requiresAuth,
//       ...meta
//     }
//   };
// };
export default [
    {
        name: 'customerSeasManage',
        path: '/manage/customer/customer',
        hidden: true,
        component: function () { return import('@/wkcrmViews/admin/crm/customer/index.vue'); },
        meta: {
            requiresAuth: true,
            permissions: ['manage', 'crm', 'pool'],
            title: '客户公海规则设置'
        }
    },
];
